import axios from './axios.js'
import {app_version} from '../config/app.js';
export default {
	get(url){
		return axios.get(url)
	},
	post(url,data){
		let form = {
			token:window.localStorage.getItem('token')||'',
			client_type:'pc_web',
			client_version:app_version,
			client_platform:'windows',
			project:'quanlang',
			...data
		}
		return axios.post(url,form)
	}
}
